import { map } from 'rxjs/operators';
import { IAppState } from 'src/app/store/state/app.state';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import * as fromSystemLoader from './../selectors/system-loader.selectors';
import * as SystemLoaderActions from './../actions/system-loader.actions';

@Injectable()
export class SystemLoaderFacade {

    public isLoading$: Observable<boolean> = this.store.pipe(
        select(fromSystemLoader.numActiveProcesses$),
        map((numActiveprocesses) => {
            return !!numActiveprocesses ? true : false;
        }));

    constructor(private store: Store<IAppState>) { }
}
